import React from 'react';
import {Field, reduxForm} from 'redux-form';
import label from '../../utils/lngEn';
import FormField from '../common/FormField';
import {Modal} from 'react-bootstrap';

import DropdownList from 'react-widgets/lib/DropdownList';
import Multiselect from 'react-widgets/lib/Multiselect';

const renderDropdownList = ({ input, ...rest}) =>
  <DropdownList {...input} {...rest}/>


const renderMultiselect = ({ input, ...rest }) =>
  <Multiselect {...input}
               onBlur={() => input.onBlur()}
               value={input.value || []} // requires value to be an array
               {...rest}/>

const AddRestrictionForm = (props) => {
  const {handleSubmit, submitting, onCancel, coursesArray, errorName,errorKind,errorLimit,errorCourses} = props;
  return (
    <form onSubmit={handleSubmit} className="mt-4">
      <div className="form-group">
        <label htmlFor="name">{label.addConfFormName}</label>
        <Field
          name="name"
          type="text"
          component={FormField}
          description={label.addConfFormNameDesc}/>
        {errorName ?
          <div className="mt-n-2">
          <span className="text-danger">{errorName}</span>
          </div>
          :null}
      </div>
      <div className="form-group">
        <label htmlFor="kind">Restriction Kind</label>
        <Field
          name="kind"
          valueField="value"
          textField="option"
          data={[
            {option: 'Number', value: '1'},
            {option: 'Weight', value: '2'}]}
          component={renderDropdownList}
        />
        <span className="input-description">Select a Restriction Kind from the dropdown.</span>
        {errorKind ?
          <div>
          <span className="text-danger">{errorKind}</span>
          </div>
          :null}
      </div>
      <div className="form-group">
        <label htmlFor="limit">Restriction Limit</label>
        <Field
          name="limit"
          valueField="value"
          textField="option"
          data={[
            {option: 'None allowed', value: '0'},
            {option: 'Limit One', value: '1'},
            {option: 'Limit Two', value: '2'},
            {option: 'Limit Three', value: '3'}]}
          component={renderDropdownList}
        />
        <span className="input-description">Select a Restriction Limit from the dropdown.</span>
        {errorLimit ?
          <div>
          <span className="text-danger">{errorLimit}</span>
          </div>
          :null}
      </div>
      <Field name="is_time_conflict" id="is_time_conflict" component="input" type="hidden"/>
      <Field name="id" id="confId" component="input" type="hidden"/>
      <p className="mt-3">Classes Included in Conflict:</p>
      <div>
        <label htmlFor="classes">Classes</label>
        <Field
          name="courses"
          component={renderMultiselect}
          textField="slug"
          valueField="id"
          data={coursesArray}/>
        <span className="input-description">Select classes for conflict.</span>
        {errorCourses ?
          <div>
          <span className="text-danger">{errorCourses}</span>
          </div>
          :null}
      </div>
      <Modal.Footer className="mt-4">
        <button type="button" onClick={onCancel} className="btn  btn-ter pull-left">Cancel</button>
        <button className="btn btn-primary pull-right" type="submit" disabled={submitting}>Save</button>
      </Modal.Footer>
    </form>
  )
}

export default reduxForm({
  form: 'AddRestrictionForm'
})(AddRestrictionForm);



// WEBPACK FOOTER //
// ./src/components/runs/AddConflictForm.js